import React from 'react';
import { Navbar, Nav, Container, Row, Col, Button, Card } from 'react-bootstrap';
import { 
  Smartphone, 
  ShoppingBasket, 
  Settings, 
  CheckCircle, 
  Truck, 
  History, 
  Headphones, 
  Waves, 
  FlaskConical, 
  Calendar 
} from 'lucide-react';
import './Howtowork.css';
import HowtoWorkSecond from "./HowtoWorkSecond/HowtoWorkSecond"
const HowtoWork = () => {
  return (
    <div className="">
      {/* Navigation */}
       
      <main className="pt-5">
        {/* Hero Section */}
<section className="hero-sectionssss">
  <div className="hero-overlay"></div>

  <Container className="content-wrapper">
    

  <h3 className="hero-title text-white mt-5">
       HOW IT WORKS <br />
      How Does a Laundry Service Work? <br />
      <span className="text-teal" style={{color:"#051c7b"}}>
        Processes, Costs, and Quality
      </span>
    </h3>
 <br />
 <br />
  </Container>
</section>

      
       
     
<HowtoWorkSecond />
        {/* Final CTA */}
      
      </main>

<section className="cta-section py-5 px-2">
  <Container className="cta-container rounded-5 text-white position-relative overflow-hidden">

    <div className="cta-content">
      
      <h2 className="cta-title">
        Experience Pristine Care Today
      </h2>

      <p className="cta-text">
        Join thousands of clients who trust their most precious garments to our 25-year expertise.
      </p>

      <div className="cta-buttons">
        <Button className="btn-cta-outline" style={{backgroundColor:"rgb(25 135 29)"}}>
          BOOK NOW
        </Button>
        <Button className="btn-cta-outline">
          OUR SERVICES
        </Button>
      </div>

    </div>

  </Container>
</section>
     
    </div>
  );
};

export default HowtoWork;